import { render } from "./ProfileChartHeader.vue?vue&type=template&id=5b751c69"
import script from "./ProfileChartHeader.vue?vue&type=script&lang=js"
export * from "./ProfileChartHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__